import {
  validatePaginatedResponseWithSchema,
  validateWithSchema,
} from "@/helpers/common";
import { formatString } from "@/helpers/formatting";
import {
  checkoutTemplateBaseSchema,
  checkoutTemplateSchema,
} from "@/models/checkout";
import { axiosClient } from "@/services/client";
import endpoints from "@/services/endpoints";

import type { CheckoutTemplate, CheckoutTemplateBase } from "@/models/checkout";
import type { IPaginatedResponse } from "@/models/common";

class CheckoutTemplateService {
  async create(template: CheckoutTemplate) {
    const { data } = await axiosClient<{ data: CheckoutTemplate }>({
      method: "POST",
      url: endpoints.CHECKOUT_TEMPLATES.ALL,
      data: template,
    });

    return validateWithSchema(checkoutTemplateSchema, data.data);
  }

  async getAll(params?: Record<string, unknown>) {
    const { data } = await axiosClient<
      IPaginatedResponse<CheckoutTemplateBase>
    >({
      url: endpoints.CHECKOUT_TEMPLATES.ALL,
      params,
    });

    validatePaginatedResponseWithSchema(checkoutTemplateBaseSchema, data);

    return { templates: data.data, meta: data.meta };
  }

  async getById(id: string) {
    const { data } = await axiosClient<{
      data: CheckoutTemplate & { id: string };
    }>({
      url: formatString(endpoints.CHECKOUT_TEMPLATES.SINGLE, id),
    });

    return validateWithSchema(checkoutTemplateSchema, data.data);
  }

  async update(template: CheckoutTemplate) {
    const url = formatString(
      endpoints.CHECKOUT_TEMPLATES.SINGLE,
      template.id ?? ""
    );

    const { data } = await axiosClient<{
      data: CheckoutTemplate & { id: string };
    }>({
      method: "PUT",
      url,
      data: template,
    });

    return validateWithSchema(checkoutTemplateSchema, data.data);
  }

  async deleteById(id: string) {
    await axiosClient({
      method: "DELETE",
      url: formatString(endpoints.CHECKOUT_TEMPLATES.SINGLE, id),
    });
  }
}

const checkoutTemplateService = new CheckoutTemplateService();
export default checkoutTemplateService;
